const MASTERY_KEY = 'quiz_mastery_v2';
const BOOKMARK_KEY = 'quiz_bookmarks_v1';

export interface MasteryRecord {
  [questionId: string]: number; // correct count
}

function loadMastery(): MasteryRecord {
  try {
    const raw = localStorage.getItem(MASTERY_KEY);
    if (!raw) return {};
    return JSON.parse(raw) as MasteryRecord;
  } catch {
    return {};
  }
}

function saveMastery(record: MasteryRecord) {
  localStorage.setItem(MASTERY_KEY, JSON.stringify(record));
}

/** Record a correct answer for a question. Increments the count. */
export function recordCorrect(questionId: string) {
  const record = loadMastery();
  record[questionId] = (record[questionId] || 0) + 1;
  saveMastery(record);
}

/** Record an incorrect answer for a question. Resets the count to 0. */
export function recordIncorrect(questionId: string) {
  const record = loadMastery();
  record[questionId] = 0;
  saveMastery(record);
}

/** Get the mastery record for all questions */
export function getMasteryRecord(): MasteryRecord {
  return loadMastery();
}

/** Get mastery level for a single question: 0=未学習, 1=学習中, 2+=習熟済 */
export function getMasteryLevel(questionId: string): number {
  const record = loadMastery();
  return record[questionId] || 0;
}

/** Reset mastery data */
export function resetMastery() {
  localStorage.removeItem(MASTERY_KEY);
}

/** Toggle bookmark status in local storage */
export function toggleBookmarkLocal(questionId: string): boolean {
  const bookmarks = getBookmarksLocal();
  const currentStatus = bookmarks[questionId] || false;
  const newStatus = !currentStatus;
  
  bookmarks[questionId] = newStatus;
  localStorage.setItem(BOOKMARK_KEY, JSON.stringify(bookmarks));
  
  return newStatus;
}

/** Get all bookmarks from local storage */
export function getBookmarksLocal(): Record<string, boolean> {
  try {
    const stored = localStorage.getItem(BOOKMARK_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}

/** Check if question is bookmarked in local storage */
export function isBookmarkedLocal(questionId: string): boolean {
  const bookmarks = getBookmarksLocal();
  return bookmarks[questionId] || false;
}
